import { render, staticRenderFns } from "./BaseStepper.vue?vue&type=template&id=2d5bcfbe&"
import script from "./BaseStepper.vue?vue&type=script&lang=ts&"
export * from "./BaseStepper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports